import { advanceWorkspaceAccountGeneration } from '../collab/workspace-identity';
import { resetCoalescedGet } from '../lib/coalesced-get';
import { resetProjectDisplaySnapshots } from '../state/project-display-cache';
import { clearHomeComposerAttachments } from '../state/home-composer-stash';

let accountId: string | null = null;
let boundary = 0;

/** Called before mounting the authenticated app, including cross-tab sign-in. */
export function setCompanyProjectAccount(id: string | null): void {
  if (accountId === id) return;
  accountId = id;
  advanceWorkspaceAccountGeneration(`company-account:${++boundary}:${id ?? 'signed-out'}`);
  resetCoalescedGet();
  resetProjectDisplaySnapshots();
  clearHomeComposerAttachments();
}

export function companyDraftStorageKey(key: string): string {
  return accountId ? `${key}:account:${accountId}` : key;
}
